import { HttpContextToken } from '@angular/common/http';

export const BUTTON_LOADING_ID = new HttpContextToken<string | null>(() => null);
